<template>
  <div>
    <form
      autocomplete="off"
      class="form-input"
      v-on:submit="handleSearchSubmit"
    >
      <div class="search-input">
        <div class="dsr-search-box" id="search-box-area">
          <div class="search-input">
            <input
              autocapitalize="off"
              autocomplete="off"
              autocorrect="off"
              class="input-text-1 focus:shadow-outline focus:outline-0"
              id="search-box-input"
              placeholder="Categories"
              type="text"
              v-model="query"
              v-on:focus="handleSearchInputFocus"
              v-on:input="autoSearchTerms"
            />
            <div class="clear-search" v-if="query" v-on:click="clearSearch">
              <close></close>
            </div>
          </div>

          <div v-if="isSearching">
            <div class="search__dropdown" id="suggestions">
              <div class="close" v-on:click="stopSearching">
                <close></close>
              </div>

              <div v-if="hasRetrievedTerms">
                <div
                  :key="term.name"
                  class="search-term-item"
                  v-for="term in filteredTerms"
                  v-on:click="handleTermClick(term)"
                >
                  <span
                    class="search-term-item-value"
                    v-html="term.name"
                  ></span>
                </div>
              </div>

              <div v-if="showOopsNoResults">
                <div>
                  <span class="button-1 inline-block" v-on:click="createTerm"
                    >
                    Add <span class="font-bold">{{ this.query }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- #search-box-area -->
      </div>
      <!-- .search-input -->
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "../../env.js";
import Close from "../ui/Close.vue";

export default {
  data() {
    return {
      searchTerms: [],
      isSearching: false,
      query: ""
    };
  },
  components: {
    Close
  },
  props: ["note"],
  computed: {
    showOopsNoResults() {
      // If there are no results and the query is not blank (the user is searching for something)
      return !this.hasRetrievedTerms && this.query !== "";
    },
    hasRetrievedTerms() {
      return this.searchTerms.length > 0;
    },
    filteredTerms() {
      let filteredTerms = [];
      if (this.note) {
        let termNames = [];
        this.note.terms.map(term => {
          termNames.push(term.name);
        });
        filteredTerms = this.searchTerms.filter(term => {
          return !termNames.includes(term.name);
        });
      }
      return filteredTerms;
    }
  },
  mounted() {
    // If the user clicks outside of the search-box-area, close the suggestions
    let searchBoxArea = document.getElementById("search-box-area");

    searchBoxArea.addEventListener("click", function(e) {
      e.stopPropagation(); // this will stop propagation of this event to upper level
    });

    let that = this;
    document.body.addEventListener("click", function(e) {
      that.isSearching = false;
    });
  },

  beforeDestroy: function() {
    this.$store.dispatch("aSetNoteTerms", []);
  },

  methods: {
    createTerm() {
      const term = {
        name: this.query,
        note_id: this.note.id,
        taxonomy: 'category',
      };
      this.note.terms.unshift(term);
      let bracketedTerm = '[' + term.name + ']';
      let noteTermList = this.note.term_list ? this.note.term_list + bracketedTerm : bracketedTerm;
      this.note.term_list = noteTermList;
      this.query = '';
      this.isSearching = false;
    },
    handleTermClick (term) {
      this.note.terms.unshift(term);
      let bracketedTerm = '[' + term.name + ']';
      let noteTermList = this.note.term_list ? this.note.term_list + bracketedTerm : bracketedTerm;
      this.note.term_list = noteTermList;
      // Close the suggestions box
      this.isSearching = false;
      this.query = '';
    },

    handleSearchSubmit (e) {
      e.preventDefault();
      this.isSearching = false;
      this.handleSearch(this.query);
    },
    clearSearch (e) {
      e.preventDefault();
      this.isSearching = false;
      const clearingSearch = true;
    },

    handleInputSearch (e) {
      const query = e.target.value;

      this.handleSearch(query);
    },

    autoSearchTerms() {
      if (this.query.length % 2 === 0) {
        this.handleSearch(this.query);
      }
    },

    handleSearch (query) {
      // if the query is blank, don't search
      if (query === "") {
        this.isSearching = false;
        this.searchTerms = [];
        return;
      }
      let uri = `${API_URL}/terms/search?query=${query}`;
      axios.get(uri).then(res => {
        this.searchTerms = res.data;
        this.isSearching = true;
      });
      this.isSearching = true;
    },

    handleSearchInputFocus() {
      // Only do this inital search for the sections if
      // the user hasn't searched for anything or if they've
      // cleared their search
      if (this.query === "") {
        let uri = `${API_URL}/admin/books/terms/search-on-focus?book=${this.note.book_id}&popular=true`;
        axios.get(uri, this.$store.getters.authHeaders).then(res => {
          this.searchTerms = res.data;
          this.isSearching = true;
        });
      } else {
        this.isSearching = true;
      }
    },

    stopSearching: function() {
      this.isSearching = false;
    }
  }
};
</script>

<style lang="scss">
.clear-search {
  position: absolute;
  padding: 9px;
  z-index: 1;
  right: 5px;
  top: 0px;
}

.clear-search svg {
  fill: #aaa;

  cursor: pointer;
}

.clear-search svg:hover {
  fill: #700;
}
.page .clear-search {
  right: 0px;
  padding: 15px;
}

@media (min-width: 768px) {
  // On Desktop, move the icons (X button on search and
  // marker for location) back in position.
  .clear-search {
    right: 8px;
  }
}

.terms-search .close {
  right: 0px;
  position: absolute;
  padding: 10px;
  cursor: pointer;
}
</style>
